import React, { useEffect, useState } from "react";
import "../NavBar/Header.css";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import logo from '../../Images/logo/logo.png';
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { LiaUserSolid } from "react-icons/lia";
import { Dropdown } from "react-bootstrap";
import { useDispatch,useSelector } from "react-redux";
import { getProfile, getToken } from "../localstorage/localStorageServices";
import { setUserToken } from "../../features/authSlice";
import Eventsdata from "../../Data/Eventsdata";

const Header = (() => {
  const [sposition,setSposition]=useState(0)
  const [navclass,setNavclass]=useState('navstylef')
  useEffect(()=>{
    const onscrolleffect=()=>{
     setSposition(window.scrollY)
    }
    window.addEventListener('scroll',onscrolleffect)
    return(()=>{
     window.removeEventListener('scroll',onscrolleffect)
   }
    )
  },[])
  useEffect(() => {
    if (sposition>155) {
      setNavclass('navstylenf');
    } else {
      setNavclass('navstylef');
    }
  }, [sposition]);
    const location = useLocation();

    // Check if the current route is "/booking" or starts with "/booking/"
    const isBookingRoute = location.pathname.startsWith("/booking");

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { access_token } = getToken();
    const { profile } = getProfile();
    const [expanded, setExpanded] = useState(false);
    const { token } = useSelector((state) => state.auth);
  
    useEffect(() => {
      dispatch(setUserToken({ token: access_token }));
    }, [access_token, dispatch]);
    const handleNavbarToggle = () => {
      setExpanded(!expanded);
    };
    const logoutHandle = () => {
      sessionStorage.removeItem("access_token");
      sessionStorage.removeItem("profile");
      localStorage.clear();
      sessionStorage.clear();
      navigate("/");
    };
    const handleLinkClick = () => {
      setExpanded(false); // Close Navbar when a NavItem is clicked
    };
    const textcolor = navclass==='navstylenf'?'mx-1 nav-link text-dark':'mx-1 nav-link navcolor'
    return (
        <>
            <div className="navbar-banner">
                <Navbar collapseOnSelect expand="lg" 
                // className={isBookingRoute ? "navbar-bg-black" : "navbar-bg-black" }
                className={navclass}
                >
                    <Container className="mx-auto">
                    <Navbar.Collapse id="responsive-navbar-nav  ">
                            <Nav className="navbar-links me-4 d-none d-lg-flex" style={{justifyContent:"end"}}>
                                <NavLink to="/"  className={textcolor}><p>Home</p></NavLink>
                                <NavLink to="/top-resort-neral"  className={textcolor}><p>About Us</p></NavLink>
                                <NavLink to="/resort-with-rooms-neral"  className={textcolor}><p>Room's</p></NavLink>
                                <Dropdown className="d-flex d-lg-block justify-content-center" style={{flexDirection:'column'}}>
                      <Dropdown.Toggle
                        id="dropdown-basic"
                        className={textcolor}
                      >
                        Events
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {Eventsdata.map((data)=>(
                        <Dropdown.Item as={Link} to={data.slugs}>
                          {data.name}
                        </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                               
                            </Nav>
                            <Nav>
                            {/* <div className="login-Navbar-main-con">
                <div className="Responsive-Navbar-Profile-con" >
                
                    <NavLink
                      to="/resort-with-rooms-neral"
                      className="signinbuttionsection"
                    >
                      <Link className="nev-color" to="/resort-with-rooms-neral">
                        <button className="sign-up-button">
                         
                         Book Now
                        </button>
                      </Link>
                    </NavLink>
                  
                </div>
              </div> */}
                            </Nav>
                        </Navbar.Collapse>
                        <Navbar.Brand to="#home">
                            <div className="nav-bar-logo-main-con">
                                <div className="nav-bar-logo" style={{height:"60px"}}>
                                  <NavLink to='/'>
                                    <img src={logo} alt="Seema Resort" style={{height:'100px'}} />
                                    </NavLink>
                                </div>
                            </div>
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                        <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="navbar-links me-4 d-lg-none" style={{justifyContent:"end"}}>
                                <NavLink to="/"  className={textcolor}><p>Home</p></NavLink>
                                <NavLink to="/top-resort-neral"  className={textcolor}><p>About Us</p></NavLink>
                                <NavLink to="/resort-with-rooms-neral"  className={textcolor}><p>Room's</p></NavLink>
                                <Dropdown className="d-flex d-lg-block justify-content-center" style={{flexDirection:'column'}}>
                      <Dropdown.Toggle
                        id="dropdown-basic"
                        className="nav-link "
                      >
                        Events
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {Eventsdata.map((data)=>(
                        <Dropdown.Item as={Link} to={data.slugs}>
                          {data.name}
                        </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                               
                            </Nav>
                            <Nav className="navbar-links">
                               
                                <NavLink to="/family-resort-neral"  className={textcolor}><p>Gallery</p></NavLink>
                                <NavLink to="/best-resort-neral"  className={textcolor}><p>Attractions</p></NavLink>
                                <NavLink to="/resort-near-neral"  className={textcolor}><p>Contact Us</p></NavLink>
                                {/* <NavDropdown title="Others" id="collapsible-nav-dropdown">
                                    <NavDropdown.Item to="#action/3.1">Our Client</NavDropdown.Item>
                                    <NavDropdown.Item to="#action/3.2">
                                        Testimonial
                                    </NavDropdown.Item>
                                    <NavDropdown.Item to="#action/3.3">Gallery</NavDropdown.Item>
                                </NavDropdown> */}
                            </Nav>
                            
                            <Nav>
                            {/* <div className="login-Navbar-main-con">
                <div className="Responsive-Navbar-Profile-con" >
                
                    <NavLink
                      to="/resort-with-rooms-neral"
                      className="signinbuttionsection"
                    >
                      <Link className="nev-color" to="/resort-with-rooms-neral">
                        <button className="sign-up-button">
                         
                         Book Now
                        </button>
                      </Link>
                    </NavLink>
                  
                </div>
              </div> */}
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </div>
            
        </>
    )
});
export default Header;